import React from 'react'
import { useIntl } from 'react-intl'
import withAuth from '../../../components/withAuth'
import TasksContent from './TasksContent'
import LoanPage from '../../../components/LoanPage'

const Tasks = () => {
	const { formatMessage } = useIntl()
	return (
		<LoanPage
			page="tasks"
			isFullWidth
			breadcrumbs={[
				{
					label: formatMessage({ id: 'breadcrumbs.tasks' }),
					value: 'tasks',
				},
			]}
		>
			<TasksContent className="overflow-auto" />
		</LoanPage>
	)
}

export default withAuth(Tasks)
